module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('el-button', {
    staticClass: "float-right",
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'customers'
      }
    }
  }, [_vm._v("\n            Customers\n          ")])], 1)])], 1), _vm._v(" "), _c('section', {
    staticClass: "content customers-content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list
    }
  }, [_c('template', {
    slot: "empty"
  }, [_vm._v("\n              Loading...\n            ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": "Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-row', [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "View",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          staticClass: "btn-rounded",
          attrs: {
            "type": "success",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.handleView(scope.row)
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Edit",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          staticClass: "btn-rounded",
          attrs: {
            "type": "primary",
            "icon": "el-icon-edit",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Delete",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          staticClass: "btn-rounded",
          attrs: {
            "type": "danger",
            "icon": "el-icon-delete",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.row)
            }
          }
        })], 1)], 1)]
      }
    }])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.pagination.pageSize,
      "layout": "prev, pager, next, sizes",
      "total": _vm.pagination.totalCount,
      "page-sizes": _vm.pagination.rowsPerPageItems,
      "current-page": _vm.pagination.pageNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69a823be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/customers/Index.vue
// module id = 1157
// module chunks = 2